import { DefaultService } from '@/services/DefaultService';

export default class TipoOcorrenciaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	updateSituacao(tipoocorrencia) {
    return this._http.post(`${this._env}/agro/tipoocorrencia/updatesituacao`, tipoocorrencia, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/tipoocorrencia.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    findAllCombo(params, contexto = "agro") {
        return this.findAllComboSituacao(1, contexto, params)
    }
    findAllComboSituacao(situacao = 1, contexto, ...params) {
		return this._http.get(encodeURI(`${this._env}/${contexto}/getcombo/tipoocorrencia.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

	find(id) {
		return this._http.get(`${this._env}/agro/tipoocorrencia/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

	findByAgroVisita(idagrovisita) {
		return this._http.get(encodeURI(`${this._env}/agro/tipoocorrencia/agro-visita/${idagrovisita}.json`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	save(form) {
		return this._http.post(`${this._env}/agro/tipoocorrencia`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

}